import { useEffect } from "react";
import RoutesProvider from "./routes";
import 'animate.css'
import WOW from "wowjs";

function App() {
  useEffect(()=>{
    const wow = new WOW.WOW();
    wow.init();

  },[])
  return <RoutesProvider/>
}

export default App;
